function isRxEntryOptional(rxEntryType) {
    return rxEntryType === 'rx-entry-optional';
}
function isRxEntryRequired(rxEntryType) {
    return rxEntryType === 'rx-entry-required';
}
function isNoRxEntry(rxEntryType) {
    return rxEntryType === 'no-rx-entry';
}

export { isNoRxEntry, isRxEntryOptional, isRxEntryRequired };
//# sourceMappingURL=typeguards.js.map
